(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguegames/assets/javascripts/models/statleaguegames.js') >= 0) return;  svs.modules.push('/components/statistics/leaguegames/assets/javascripts/models/statleaguegames.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var matchCount = svs.statistics.constants.DEFAULT_LEAGUES_LOAD_COUNT;

  svs.statistics.models.StatLeagueGames = Backbone.Model.extend({
    url: function() {
      this.leagueId = this.attributes.leagueId;
      return [
        svs.core.jupiter.url(),
        '/search/query?ctx=sport_match&type=sport_match',
        '&infilter=payload.match.league.',
        svs.statistics.common.getLeaguesIdKey(this.leagueId),
        ';',
        this.leagueId,
        '&sort=payload.match.startTime',
        this.urlArguments()
      ].join('');
    },

    initialize: function() {
      _.bindAll(this, 'onError');
      this.listenTo(this, 'error', this.onError);

      this.selection = 'range';
      this.fromDate = null;
      this.toDate = null;
      this.page = 0;
      this.isExpanding = false;

      this.matchCollection = this.matchCollection
        ? this.matchCollection
        : new svs.statistics.collections.Matches();

      if ((((svs.statistics || {}).data || {}).leagueModels || {}).matches) {
        this.set(this.parse(svs.statistics.data.leagueModels.matches));
      }
    },

    onError: function() {
      this.matchCollection.reset();
    },

    urlArguments: function() {
      if (this.fromDate) {
        return [
          '&rangefilter=payload.match.startTime;gte;',
          this.fromDate.toJSON(),
          ',payload.match.startTime;lte;',
          this.toDate.toJSON(),
          '&offset=',
          this.page * matchCount,
          '&count=',
          matchCount
        ].join('');
      }
      return [
        '&rangefilter=payload.match.startTime;gte;now/d-2w',
        '&offset=',
        this.page * matchCount,
        '&count=',
        matchCount
      ].join('');
    },
    setSelection: function(date) {
      if (date.length === 6) {
        this.fromDate = moment(date, 'YYYYMM');
        this.toDate = moment(date, 'YYYYMM').add(1, 'M');
      } else if (date !== '0') {
        this.fromDate = moment(date, 'YYYY-MM-DD');
        this.toDate = moment(date, 'YYYY-MM-DD').endOf('isoWeek');
      } else {
        this.fromDate = null;
        this.toDate = null;
      }
      this.page = 0;
      this.fetch();
    },
    expandSelection: function() {
      this.page += 1;
      this.isExpanding = true;
      this.fetch();
    },

    parse: function(response) {
      if (response.error !== null) {
        return response;
      }
      if (!this.isExpanding) {
        this.matchCollection.reset();
      }
      _.each(
        response.result,
        function(result) {
          var match = result.payload.match;
          if (_.isObject(match)) {
            match.displayDate = moment(match.startTime).format('D/M');

            this.matchCollection.push(match);
          }
        },
        this
      );

      response.morePages =
        this.page * matchCount + matchCount <= (response.totalCount || 0);

      this.isExpanding = false;
      return response;
    },

    getMatchesGroupedByDate: function() {
      return this.matchCollection.groupBy(function(model) {
        return model.get('displayDate');
      });
    }
  });
})(Backbone, _, svs);

 })(window);